import React, { useCallback, useState, useEffect } from 'react';
import { callAlertWeb, callAppLoginWeb, callNativeWeb, exceptionEventWeb, footerShowEventWeb } from 'common/appInterface';

const CommonTest = (props) => {

  const callback = useCallback(() => {
      props.setMain(true);
  }, [props]);

  const [screenId, setScreenId] = useState("");
  const [screenName, setScreenName] = useState("");
  const [alertTitle, setAlertTitle] = useState("");
  const [alertCode, setAlertCode] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [exceptionCode, setExceptionCode] = useState("");
  const [exceptionMessage, setExceptionMessage] = useState("");
  const [processPolicy, setProcessPolicy] = useState("1");
  const [showYn, setShowYn] = useState("Y");

  // callNative_Web 처리 (WEB > APP)
  const callNative = useCallback(() => {
    callNativeWeb(screenId, screenName);
  }, [screenId, screenName]);

  // callAlert_Web 처리 (WEB > APP)
  const callAlert = useCallback(() => {
    callAlertWeb(alertTitle, alertCode, alertMessage);
  }, [alertTitle, alertCode, alertMessage]);

  // exceptionEvent_Web 처리 (WEB > APP)
  const exceptionEvent = useCallback(() => {
    exceptionEventWeb(exceptionCode, exceptionMessage, processPolicy);
  }, [exceptionCode, exceptionMessage, processPolicy]);

  // callAppLogin_Web 처리 (WEB > APP)
  const callAppLogin = useCallback(() => {
    callAppLoginWeb();
  }, []);

  // footerShowEvent_Web 처리 (WEB > APP)
  const footerShowEvent = useCallback(() => {
    footerShowEventWeb(showYn);
  }, [showYn]);

  // backKeyEvent_App 처리 (APP > WEB)
  const backKeyEvent = useCallback(() => {
    alert("Press BackKey");
  }, []);

  // APP이벤트 공통 수신처리 (APP > WEB)
  useEffect(() => {
    document.addEventListener("backpress", backKeyEvent);
    return () => document.removeEventListener("backpress", backKeyEvent);
  }, [backKeyEvent]);

  return (
    <div id="container">
      <section className="contents">
        <div className="singUpWrapSub">
          <div className="txtWrap">
            <p className="mainTxt">backKeyEvent_App</p>
          </div>
          <div className="conWrap mgt30">
            <div className="inputBoxTy01"> 
              <label className="mgb20">
                <input type="text" value="" readOnly />
                <span>뒤로가기 캐치 시 얼랏이 나옵니다.</span>
              </label>
            </div>
          </div>
        </div>
        <div className="singUpWrapSub">
          <div className="txtWrap">
            <p className="mainTxt">callNative_Web</p>
          </div>
          <div className="conWrap mgt30">
            <div className="inputBoxWrapTy01" style={{overflow: "initial"}}>
              <div className="inputBoxTy01"> 
                <label className="mgb20">
                  <input type="text" value={screenId} onChange={(e) => setScreenId(e.target.value)} />
                  <span>screenId</span>
                </label>
              </div>
              <div className="inputBoxTy01"> 
                <label className="mgb20">
                  <input type="text" value={screenName} onChange={(e) => setScreenName(e.target.value)} />
                  <span>screenName</span>
                </label>
              </div>
            </div>
            <div className="btnWrapTy01">
              <button type="button" className="btnPrimaryTy01" onClick={callNative}><span>callNative_Web Call</span></button>
            </div>
          </div>
        </div>
        <div className="singUpWrapSub">
          <div className="txtWrap">
            <p className="mainTxt">callAlert_Web</p>
          </div>
          <div className="conWrap mgt30">
            <div className="inputBoxTy01"> 
              <label className="mgb20">
                <input type="text" value={alertTitle} onChange={(e) => setAlertTitle(e.target.value)} />
                <span>title</span>
              </label>
            </div>
            <div className="inputBoxTy01"> 
              <label className="mgb20">
                <input type="text" value={alertCode} onChange={(e) => setAlertCode(e.target.value)} />
                <span>code</span>
              </label>
            </div>
            <div className="inputBoxTy01"> 
              <label className="mgb20">
                <input type="number" value={alertMessage} onChange={(e) => setAlertMessage(e.target.value)} />
                <span>message</span>
              </label>
            </div>
            <div className="btnWrapTy01">
              <button type="button" className="btnPrimaryTy01" onClick={callAlert}><span>callAlert_Web Call</span></button>
            </div>
          </div>
        </div>
        <div className="singUpWrapSub">
          <div className="txtWrap">
            <p className="mainTxt">exceptionEvent_Web</p>
          </div>
          <div className="conWrap mgt30">
            <div className="inputBoxTy01"> 
              <label className="mgb20">
                <input type="text" value={exceptionCode} onChange={(e) => setExceptionCode(e.target.value)} />
                <span>code</span>
              </label>
            </div>
            <div className="inputBoxTy01"> 
              <label className="mgb20">
                <input type="text" value={exceptionMessage} onChange={(e) => setExceptionMessage(e.target.value)} />
                <span>message</span>
              </label>
            </div>
            <div className="inputBoxTy01 formSelectBoxTy02">
              <label className="mgb20" style={{margin: "0 0 45px", position: "relative", display: "inline-block", width: "100%"}}>
                <select style={{padding: "10px 0"}} value={processPolicy} onChange={(e) => setProcessPolicy(e.target.value)}>
                  <option value="1">[1] 앱종료</option>
                  <option value="2">[2] 웹뷰 종료 후 재호출</option>
                </select>
                <span style={{opacity: ".5", transform: "scale(0.75) translateY(-80%) translateX(0px)", transformOrigin: "left", padding: "10px 0", fontSize: "18px", pointerEvents: "none", position: "absolute", left: "0", top: "0", transition: "0.2s", transitionTimingFunction: "cubic-bezier(0.25, 0.1, 0.25, 1)"}}>processPolicy</span>
              </label>
            </div>
            <div className="btnWrapTy01">
              <button type="button" className="btnPrimaryTy01" onClick={exceptionEvent}><span>exceptionEvent_Web Call</span></button>
            </div>
          </div>
        </div>
        <div className="singUpWrapSub">
          <div className="txtWrap">
            <p className="mainTxt">callAppLogin_Web</p>
          </div>
          <div className="conWrap mgt30">
            <div className="btnWrapTy01">
              <button type="button" className="btnPrimaryTy01" onClick={callAppLogin}><span>callAppLogin_Web Call</span></button>
            </div>
          </div>
        </div>
        <div className="singUpWrapSub">
          <div className="txtWrap">
            <p className="mainTxt">footerShowEvent_Web</p>
          </div>
          <div className="conWrap mgt30">
            <div className="inputBoxTy01 formSelectBoxTy02">
              <label className="mgb20" style={{margin: "0 0 45px", position: "relative", display: "inline-block", width: "100%"}}>
                <select style={{padding: "10px 0"}} value={showYn} onChange={(e) => setShowYn(e.target.value)}>
                  <option value="Y">[Y] 보여주기</option>
                  <option value="N">[N] 숨기기</option>
                </select>
                <span style={{opacity: ".5", transform: "scale(0.75) translateY(-80%) translateX(0px)", transformOrigin: "left", padding: "10px 0", fontSize: "18px", pointerEvents: "none", position: "absolute", left: "0", top: "0", transition: "0.2s", transitionTimingFunction: "cubic-bezier(0.25, 0.1, 0.25, 1)"}}>showYn</span>
              </label>
            </div>
            <div className="btnWrapTy01 mgb120">
              <button type="button" className="btnPrimaryTy01" onClick={footerShowEvent}><span>footerShowEvent_Web Call</span></button>
            </div>
          </div>
        </div>
      </section>
      <div className="btnArea">
        <div className="btnWrapTy01">
          <button type="button" className="btnPrimaryTy01 mgb60" onClick={callback}><span>메뉴복귀</span></button>
        </div>
      </div>
    </div>
  );
}

export default CommonTest;